export default __webpack_public_path__ + "static/realWorldImg1-de14f714e2e2dc5cafd2e6270389dc56.webp";